var _a;
import { useSelector } from 'react-redux';
import { gieLinksSlice } from './gieLinksSlice';
import { gieLinksModuleApi } from './gieLinksModuleApi';
export var gieLinksReducers = (_a = {},
    _a[gieLinksSlice.name] = gieLinksSlice.reducer,
    _a[gieLinksModuleApi.reducerPath] = gieLinksModuleApi.reducer,
    _a);
export var middleware = [
    gieLinksModuleApi.middleware
];
export var useGieLinksSelector = useSelector;
